import { useTranslation } from 'react-i18next';

export const faqs = () => {
  const { t } = useTranslation();
  const faq = [
    {
      id: 0,
      title: t('faq_0_title'),
      body: t('faq_0_body'),
    },
    {
      id: 1,
      title: t('faq_1_title'),
      body: t('faq_1_body'),
    },
    {
      id: 4,
      title: t('faq_4_title'),
      body: t('faq_4_body'),
    },
    {
      id: 5,
      title: t('faq_5_title'),
      body: t('faq_5_body'),
    },
    {
      id: 6,
      title: t('faq_6_title'),
      body: t('faq_6_body'),
    },
    {
      id: 7,
      title: t('faq_7_title'),
      body: t('faq_7_body'),
    },
    {
      id: 8,
      title: t('faq_8_title'),
      body: t('faq_8_body'),
    },
    {
      id: 9,
      title: t('faq_9_title'),
      body: t('faq_9_body'),
    },
    {
      id: 10,
      title: t('faq_10_title'),
      body: t('faq_10_body'),
    },
    {
      id: 11,
      title: t('faq_11_title'),
      body: t('faq_11_body'),
    },
    {
      id: 12,
      title: t('faq_12_title'),
      body: t('faq_12_body'),
    },
    {
      id: 13,
      title: t('faq_13_title'),
      body: t('faq_13_body'),
    },
    {
      id: 14,
      title: t('faq_14_title'),
      body: t('faq_14_body'),
    },
    {
      id: 15,
      title: t('faq_15_title'),
      body: t('faq_15_body'),
    },
    {
      id: 16,
      title: t('faq_16_title'),
      body: t('faq_16_body'),
    },
    {
      id: 17,
      title: t('faq_17_title'),
      body: t('faq_17_body'),
    },
    {
      id: 18,
      title: t('faq_18_title'),
      body: t('faq_18_body'),
    },
    {
      id: 19,
      title: t('faq_19_title'),
      body: t('faq_19_body'),
    },
    {
      id: 20,
      title: t('faq_20_title'),
      body: t('faq_20_body'),
    },
  ];
  return faq;
};

export const cookies = () => {
  const { t } = useTranslation();
  const cookie = [
    {
      id: 0,
      title: t('cookie_title_0'),
      body: t('cookie_body_0'),
    },
    {
      id: 1,
      title: t('cookie_title_1'),
      body: t('cookie_body_1'),
    },
    {
      id: 2,
      title: t('cookie_title_2'),
      body: t('cookie_body_2'),
    },
    {
      id: 3,
      title: t('cookie_title_3'),
      body: t('cookie_body_3'),
    },
    {
      id: 4,
      title: t('cookie_title_4'),
      body: t('cookie_body_4'),
    },
    {
      id: 5,
      title: t('cookie_title_5'),
      body: t('cookie_body_5'),
    },
    {
      id: 6,
      title: t('cookie_title_6'),
      body: t('cookie_body_6'),
    },
    {
      id: 7,
      title: t('cookie_title_7'),
      body: t('cookie_body_7'),
    },
    {
      id: 8,
      title: t('cookie_title_8'),
      body: t('cookie_body_8'),
    },
    {
      id: 9,
      title: t('cookie_title_9'),
      body: t('cookie_body_9'),
    },
    {
      id: 10,
      title: t('cookie_title_10'),
      body: t('cookie_body_10'),
    },
    {
      id: 11,
      title: t('cookie_title_11'),
      body: t('cookie_body_11'),
    },
    {
      id: 12,
      title: t('cookie_title_12'),
      body: t('cookie_body_12'),
    },
    {
      id: 13,
      title: t('cookie_title_13'),
      body: t('cookie_body_13'),
    },
    {
      id: 14,
      title: t('cookie_title_14'),
      body: t('cookie_body_14'),
    },
    {
      id: 15,
      title: t('cookie_title_15'),
      body: t('cookie_body_15'),
    },
  ];
  return cookie;
};
export const privacy = () => {
  const { t } = useTranslation();
  const term = [
    {
      id: 0,
      title: t('privacy_title0'),
      body: t('privacy_body0'),
    },
    {
      id: 1,
      title: t('privacy_title1'),
      body: t('privacy_body1'),
      inner: [
        {
          id: `i${0}`,
          body: t('privacy_1_i0'),
        },
        {
          id: `i${1}`,
          body: t('privacy_1_i1'),
        },
        {
          id: `i${2}`,
          body: t('privacy_1_i2'),
        },
        {
          id: `i${3}`,
          body: t('privacy_1_i3'),
        },
        {
          id: `i${4}`,
          body: t('privacy_1_i4'),
        },
        {
          id: `i${5}`,
          body: t('privacy_1_i5'),
        },
        {
          id: `i${6}`,
          body: t('privacy_1_i6'),
        },
        {
          id: `i${7}`,
          body: t('privacy_1_i7'),
        },
        {
          id: `i${8}`,
          body: t('privacy_1_i8'),
        },
        {
          id: `i${9}`,
          body: t('privacy_1_i9'),
        },
        {
          id: `i${10}`,
          body: t('privacy_1_i10'),
        },
      ],
    },
    {
      id: 2,
      title: t('privacy_title2'),
      body: t('privacy_body2'),
      inner: [
        {
          id: `i${0}`,
          body: t('privacy_2_i0'),
        },
        {
          id: `i${1}`,
          body: t('privacy_2_i1'),
        },
        {
          id: `i${2}`,
          body: t('privacy_2_i2'),
        },
        {
          id: `i${3}`,
          body: t('privacy_2_i3'),
        },
        {
          id: `i${4}`,
          body: t('privacy_2_i4'),
        },
        {
          id: `i${5}`,
          body: t('privacy_2_i5'),
        },
        {
          id: `i${6}`,
          body: t('privacy_2_i6'),
        },
        {
          id: `i${7}`,
          body: t('privacy_2_i7'),
        },
      ],
    },
    {
      id: 3,
      title: t('privacy_title3'),
      body: t('privacy_body3'),
    },
    {
      id: 4,
      title: t('privacy_title4'),
      body: t('privacy_body4'),
    },
    {
      id: 5,
      title: t('privacy_title5'),
      body: t('privacy_body5'),
      inner: [
        {
          id: `i${0}`,
          body: t('privacy_5_i0'),
        },
        {
          id: `i${1}`,
          body: t('privacy_5_i1'),
        },
      ],
    },
    {
      id: 6,
      title: t('privacy_title6'),
      body: t('privacy_body6'),
    },
    {
      id: 7,
      title: t('privacy_title7'),
      body: t('privacy_body7'),
    },
  ];
  return term;
};
export const termsCon = () => {
  const { t } = useTranslation();
  const tc = [
    {
      id: 0,
      title: t('general_provisions_title'),
      inner: [
        {
          id: `i${0}`,
          body: t('general_provisions_0'),
        },
        {
          id: `i${1}`,
          body: t('general_provisions_1'),
        },
        {
          id: `i${2}`,
          body: t('general_provisions_2'),
        },
        {
          id: `i${3}`,
          body: t('general_provisions_3'),
        },
      ],
    },
    {
      id: 1,
      title: t('participation_conditions_title'),
      inner: [
        {
          id: `i${0}`,
          body: t('participation_conditions_0'),
        },
        {
          id: `i${1}`,
          body: t('participation_conditions_1'),
        },
        {
          id: `i${2}`,
          body: t('participation_conditions_2'),
        },
        {
          id: `i${3}`,
          body: t('participation_conditions_3'),
        },
      ],
    },
    {
      id: 2,
      title: t('event_program_title'),
      inner: [
        {
          id: `i${0}`,
          body: t('event_program_0'),
        },
        {
          id: `i${1}`,
          body: t('event_program_1'),
        },
        {
          id: `i${2}`,
          body: t('event_program_2'),
        },
        {
          id: `i${3}`,
          body: t('event_program_3'),
        },
        {
          id: `i${4}`,
          body: t('event_program_4'),
        },
      ],
    },
    {
      id: 3,
      title: t('safety_rules_title'),
      inner: [
        {
          id: `i${0}`,
          body: t('safety_rules_0'),
        },
        {
          id: `i${1}`,
          body: t('safety_rules_1'),
        },
        {
          id: `i${2}`,
          body: t('safety_rules_2'),
        },
        {
          id: `i${3}`,
          body: t('safety_rules_3'),
        },
        {
          id: `i${4}`,
          body: t('safety_rules_4'),
        },
      ],
    },
    {
      id: 4,
      title: t('event_behavior_title'),
      inner: [
        {
          id: `i${0}`,
          body: t('event_behavior_0'),
        },
        {
          id: `i${1}`,
          body: t('event_behavior_1'),
        },
        {
          id: `i${2}`,
          body: t('event_behavior_2'),
        },
        {
          id: `i${3}`,
          body: t('event_behavior_3'),
        },
        {
          id: `i${4}`,
          body: t('event_behavior_4'),
        },
      ],
    },
    {
      id: 5,
      title: t('organizer_rights_title'),
      inner: [
        {
          id: `i${0}`,
          body: t('organizer_rights_0'),
        },
        {
          id: `i${1}`,
          body: t('organizer_rights_1'),
        },
        {
          id: `i${2}`,
          body: t('organizer_rights_2'),
        },
        {
          id: `i${3}`,
          body: t('organizer_rights_3'),
        },
      ],
    },
    {
      id: 6,
      title: t('tickets_registration_title'),
      inner: [
        {
          id: `i${0}`,
          body: t('tickets_registration_0'),
        },
        {
          id: `i${1}`,
          body: t('tickets_registration_1'),
        },
        {
          id: `i${2}`,
          body: t('tickets_registration_2'),
        },
      ],
    },
    {
      id: 7,
      title: t('final_provisions_title'),
      inner: [
        {
          id: `i${0}`,
          body: t('final_provisions_0'),
        },
        {
          id: `i${1}`,
          body: t('final_provisions_1'),
        },
        {
          id: `i${2}`,
          body: t('final_provisions_2'),
        },
      ],
    },
  ];
  return tc;
};
